<router-outlet (activate)="onActivate()"></router-outlet>
<app-footer></app-footer>
